// extracted by mini-css-extract-plugin
export default {"wrapper":"Homepage_wrapper__aBtx-"};